import React from 'react'

import { Descriptions } from 'antd'

import { type MetricStatsMap } from '../Report'

export const Topology: React.FC<{
  metricStats: MetricStatsMap
}> = ({ metricStats }) => {
  const tidbCount = metricStats?.['TiDB_count:total']?.values?.max || 0
  const tikvCount = metricStats?.['TiKV_count:total']?.values?.max || 0
  const pdCount = metricStats?.['PD_count:total']?.values?.max || 0
  const tiflashCount = metricStats?.['TiFlash_count:total']?.values?.max || 0

  return (
    <Descriptions>
      <Descriptions.Item label='TiDB instance count'>
        {Math.round(tidbCount)}
      </Descriptions.Item>
      <Descriptions.Item label='TiKV instance count'>
        {Math.round(tikvCount)}
      </Descriptions.Item>
      <Descriptions.Item label='PD instance count'>
        {Math.round(pdCount)}
      </Descriptions.Item>
      {!!tiflashCount && (
        <Descriptions.Item label='TiFlash instance count'>
          {Math.round(tiflashCount)}
        </Descriptions.Item>
      )}
    </Descriptions>
  )
}
